module.exports = __webpack_public_path__ + "media/images/vp/icon.comment.outline.black-4e800cf1e80a307d0b90f9fe16e185ae.svg";